import { render, staticRenderFns } from "./Physician.vue?vue&type=template&id=353b672e&scoped=true&"
import script from "./Physician.vue?vue&type=script&lang=js&"
export * from "./Physician.vue?vue&type=script&lang=js&"
import style0 from "./Physician.vue?vue&type=style&index=0&id=353b672e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b672e",
  null
  
)

export default component.exports